import React, { useEffect, useMemo, useState } from "react";
import {
  GetCohortMessages,
  GetMeetingRecordings,
} from "../services/cohortService";
import noAttachment from "../assets/empty-attachment.svg";
import play from "../assets/play-circle.svg";
import file2 from "../assets/file-2.svg";
import png from "../assets/png.svg";
import elipsis from "../assets/elipsis.svg";

import { LoadingOutlined } from "@ant-design/icons";
import { getFileTypeFromUrl } from "../utils/fileHelpers";
import dayjs from "dayjs";

const CohortAttachments = ({ currentCohort }) => {
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getMessages = async () => {
    setIsLoading(true);
    setMessages([]);
    try {
      const res = await GetCohortMessages(currentCohort?.id);
      setMessages(res.data.data || []);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const attachments = useMemo(
    () => messages.filter((item) => item.image && item.message !== "---"),
    [messages]
  );

  useEffect(() => {
    if (currentCohort) {
      getMessages();
    }
  }, [currentCohort]);

  return (
    <>
      <div className="px-4 pb-4 relative">
        <div className="flex flex-col w-full h-[calc(100vh-415px)] overflow-y-auto pt-[10px] pb-[200px] mt-6">
          {isLoading ? (
            <div className="h-full flex justify-center items-center">
              <LoadingOutlined style={{ fontSize: "20px" }} />
            </div>
          ) : !attachments.length ? (
            <div className="w-full md:w-[400px] mx-auto text-center pt-[40px]">
              <img src={noAttachment} className="mx-auto" alt="" />
              <p className="text-tint">No attachments yet.</p>
            </div>
          ) : (
            <>
              <p className="text-main">Photos, videos and documents</p>
              {attachments.map((item, index) => (
                <div
                  key={index}
                  className="flex justify-between border-b border-[#ECEBF5] hover:bg-[#EFEFFE] rounded-[10px] p-2 px-3"
                >
                  <div className="flex items-center gap-2">
                    <div className="bg-[#F9F9FF] w-[44px] h-[44px] rounded-[6px] flex items-center justify-center">
                      <img
                        src={
                          getFileTypeFromUrl(item.image) === "image"
                            ? file2
                            : getFileTypeFromUrl(item.image) === "video"
                            ? play
                            : png
                        }
                        alt=""
                      />
                    </div>
                    <div>
                      <p className="m-0 text-main">{item.message}</p>
                      <p className="text-tint text-[12px]">
                        {dayjs(item.created_at).format("DD MMM YYYY hh:mma")}
                      </p>
                    </div>
                  </div>
                  <button className="p-4">
                    <img src={elipsis} alt="" />
                  </button>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default CohortAttachments;
